/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Dms_Restore_DocumentInputs */

const cs_api_error_dms_restore_document = /** @type {(inputs: Api_Error_Dms_Restore_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument se stejným názvem už v cíli existuje. Před obnovením ho odstraňte nebo přejmenujte.`)
};

const en_api_error_dms_restore_document = /** @type {(inputs: Api_Error_Dms_Restore_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A document with this name already exists in the destination. Remove or rename it before restoring.`)
};

/**
* | output |
* | --- |
* | "A document with this name already exists in the destination. Remove or rename it before restoring." |
*
* @param {Api_Error_Dms_Restore_DocumentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_dms_restore_document = /** @type {((inputs?: Api_Error_Dms_Restore_DocumentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Dms_Restore_DocumentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_dms_restore_document(inputs)
	return cs_api_error_dms_restore_document(inputs)
});